document.addEventListener('DOMContentLoaded', function() {

    // Get all elements with class "navbar" and all footer links with href="#top"
    const links = document.querySelectorAll(".navbar a, footer a[href='#top']");

    // Attach a click event listener to each of the links
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            // Prevent the default behavior of the link
            event.preventDefault();

            // Get the hash value of the link
            const hash = this.hash;

            // Scroll smoothly to the corresponding element
            const targetElement = document.querySelector(hash);
            const targetTop = targetElement.offsetTop;
            window.scrollTo({
                top: targetTop,
                behavior: "smooth"
            });

            // Set the hash value in the URL
            history.pushState(null, null, hash);
        });
    });

});